import { SwatchData } from '../../types'
import { fetchSwatches, createSwatch } from '../../services/swatches.service'
import { actions as customActions } from './swatches.actions'
import { getters as customGetters } from './swatches.getters'
import { state as customState } from './swatches.state'
import { mutations as customMutations } from './swatches.mutations'
import createBaseStore from '../createStoreHelper'

export const SwatchesModule: any = createBaseStore<SwatchData>({
  resourceName: 'swatches',
  apiCalls: {
    fetchAllApiCall: fetchSwatches,
    createApiCall: createSwatch
  }
})

SwatchesModule.actions = { ...SwatchesModule.actions, ...customActions }
SwatchesModule.getters = { ...SwatchesModule.getters, ...customGetters }
SwatchesModule.state = { ...SwatchesModule.state, ...customState }
SwatchesModule.mutations = { ...SwatchesModule.mutations, ...customMutations }
